/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.filter('notInArray', ['$filter', function ($filter) {
        return function (array, filters, element) {
            if (filters) {
                return $filter("filter")(array, function (item) {
                    for (var i = 0; i < filters.length; i++) {
                        if (filters[i][element] === item[element])
                            return false;
                    }
                    return true;
                });
            }
        };
    }]);

    app.filter('name', ['$filter', function ($filter) {
        return function (value) {
            return value.replace(/\-/g, ' ');
        };
    }]);

    app.filter('minutes', ['$filter', function ($filter) {
        return function (value) {
            //return value + ' min';
            return (value / 60 >= 1 ? (parseInt(value / 60) + "h") : "") + (value % 60 > 0 ? value % 60 + "'" : "")
        };
    }]);

    app.filter('seconds', ['$filter', function ($filter) {
        return function (value) {
            var seconds = (value / 60 >= 1 ? (parseInt(value / 60) + "'") : "") + (value % 60 > 0 ? value % 60 + "\"" : "");
            return seconds || " - ";
        };
    }]);    

    app.filter('groupBy', ['$parse', function ($parse) {
        return function (array, prop) {
            var key, pool = {}, results = [];
            angular.forEach(array, function (item) {
                key = item[prop];
                pool[key] = pool[key] || [];
                pool[key].push(item);
            });
            angular.forEach(pool, function (items, key) {
                results.push({
                    key: key,
                    items: items,
                });
            });
            return results;
        }
    }]);

    app.filter('groupPropsByKeyValue', ['$parse', function ($parse) {
        return function (array, prop, key,value) {
            var _key, pool = {}, results = [];
            angular.forEach(array, function (item, i) {                  
                if (item[prop] instanceof Array) {
                    angular.forEach(item[prop], function (elem) {
                        if (elem[key]) {
                            _key = elem[key];
                            if (pool[_key] == null) {
                                results.push({ key: _key, value: elem[value] });
                                pool[_key] = true;
                            }
                        }
                    })
                } else {
                    if (item[prop] && item[prop][key]) {
                        _key = item[prop][key];
                        if (pool[_key] == null) {
                            results.push({ key: _key, value: item[prop][value] });
                            pool[_key] = true;
                        }
                    }
                }                
            });
            return results;
        }
    }]);

    app.filter('byCategory', ['$filter', function ($filter) {
        return function (array, category) {
            return array.filter(function (item) {
                if (category) {
                    return item.tags && item.tags.length && item.tags[0].id === category.id;
                    /*
                    if (category.ids) {
                        for (var i = 0; i < category.ids.length; i++) {
                            var id = category.ids[i];
                            if (item.tags) {
                                if (item.tags[0].id === id) {
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                    */
                } else {
                    return true;
                }
            });
        };
    }]);

    app.filter('byFilters', ['$filter', function ($filter) {
        return function (array, filters) {
            return array.filter(function (item) {
                if (filters.area && filters.area.id) {
                    var has = false;
                    if (item.tags) {
                        var i = 0, t = item.tags.length;
                        while (i < t) {
                            if (item.tags[i].id === filters.area.id && item.tags[i].category === 1) {
                                has = true;
                                i = t;
                            }
                            i++;
                        }
                    }
                    return has;
                /*} else
                if (filters.category && filters.category.id) {
                    var has = false;
                    if (item.tags) {
                        var i = 0, t = item.tags.length;
                        while (i < t) {
                            if (item.tags[i].id === filters.category.id && item.tags[i].category == 0) {
                                has = true;
                                i = t;
                            }
                            i++;
                        }
                    }
                    return has;
                */
                } else {
                    return true;
                }
            });
        };
    }]);

    app.filter('resultByCategoryList', ['$filter', function ($filter) {
        return function (array, category) {
            return array.filter(function (item) {
                if (category) {
                    if (category.ids) {
                        for (var i = 0; i < category.ids.length; i++) {
                            var id = category.ids[i];
                            if (item.tags) {
                                if (item.tags[0].id === id) {
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                }
            });
        };
    }]);

    app.filter('duration', ['$filter', 'CONFIG', function ($filter, CONFIG) {
        return function (duration) {
            if (duration) {
                var date = new Date();
                date.setHours(0);
                date.setMinutes(duration);
                date.setSeconds(0);
                var hours = date.getHours();
                var minutes = date.getMinutes();
                return (hours ? hours + 'h' : '') + ' ' + (minutes ? minutes + 'm' : '');
                // return $filter('date')(date, 'hh mm');
            } else {
                return '-';
            }
        };
    }]);

    app.filter('price', ['$filter', 'CONFIG', function ($filter, CONFIG) {
        return function (price) {
            return price === 0 ? 'Free' : $filter('currency')(price, '€');
        };
    }]);

    app.filter('tagColors', ['$filter', function ($filter) {
        return function (tags) {
            var color = 'default';
            var colors = ['learn', 'improve', 'speed', 'endurance', 'fatburning', 'feelgood'];
            if (tags) {
                tags.filter(function (item) {
                    if (item.category === 2 && colors.indexOf(item.code) !== -1) {
                        color = item.code;
                    }
                });
            }
            return color;
        };
    }]);

    app.filter('tagNames', ['$filter', function ($filter) {
        return function (tags, category) {
            if (tags) {
                tags = tags.filter(function (item) {
                    if (category) {
                        return item.category === category;
                    } else {
                        return item.category === 0 || item.category === 1 || item.category === 2;
                    }
                }).map(function (item) {
                    return item.name;
                });
                return tags.join(', ');
            } else {
                return null;
            }
        };
    }]);
    
    app.filter('tagPois', ['$filter', function ($filter) {
        return function (tags, category) {
            if (tags) {
                var pois = tags.filter(function (item) {
                    return item.category === 3;
                });
                if (pois.length) {
                    var poi = pois[0];
                    return poi.name + ', ' + poi.code;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        };
    }]);

}());